"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LssDeclaration = function LssDeclaration(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.5962 7.40382C15.5328 6.34046 14.1337 5.67871 12.6371 5.53131C11.1405 5.38391 9.63917 5.75999 8.3888 6.59546C7.13842 7.43093 6.21642 8.6741 5.77989 10.1132C5.34336 11.5522 5.4193 13.0981 5.99478 14.4875C6.57027 15.8768 7.60968 17.0236 8.93592 17.7325C10.2622 18.4414 11.7932 18.6685 13.2681 18.3751C14.743 18.0817 16.0706 17.286 17.0246 16.1236C17.9786 14.9611 18.5 13.5038 18.5 12C18.5023 11.1461 18.3353 10.3002 18.0085 9.51121C17.6817 8.72228 17.2017 8.00599 16.5962 7.40382Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 15.5C14.9343 15.5001 14.8693 15.4872 14.8086 15.4621C14.7479 15.4369 14.6928 15.4001 14.6464 15.3536L8.64645 9.35356C8.60002 9.30713 8.56319 9.25201 8.53806 9.19135C8.51293 9.13068 8.5 9.06566 8.5 9C8.5 8.93434 8.51293 8.86932 8.53806 8.80866C8.56319 8.748 8.60002 8.69288 8.64645 8.64645C8.69288 8.60002 8.748 8.56319 8.80866 8.53806C8.86932 8.51293 8.93434 8.5 9 8.5C9.06566 8.5 9.13068 8.51293 9.19135 8.53806C9.25201 8.56319 9.30713 8.60002 9.35356 8.64645L15.3536 14.6464C15.4235 14.7164 15.4711 14.8055 15.4904 14.9025C15.5097 14.9994 15.4998 15.1 15.4619 15.1913C15.4241 15.2827 15.36 15.3608 15.2778 15.4157C15.1956 15.4707 15.0989 15.5 15 15.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9 15.5C8.90111 15.5 8.80444 15.4707 8.72222 15.4157C8.63999 15.3608 8.57591 15.2827 8.53806 15.1913C8.50022 15.1 8.49031 14.9994 8.50961 14.9025C8.5289 14.8055 8.57652 14.7164 8.64645 14.6464L14.6464 8.64645C14.6929 8.60002 14.748 8.56319 14.8087 8.53806C14.8693 8.51293 14.9343 8.5 15 8.5C15.0657 8.5 15.1307 8.51293 15.1913 8.53806C15.252 8.56319 15.3071 8.60002 15.3536 8.64645C15.4 8.69288 15.4368 8.748 15.4619 8.80866C15.4871 8.86932 15.5 8.93434 15.5 9C15.5 9.06566 15.4871 9.13068 15.4619 9.19135C15.4368 9.25201 15.4 9.30713 15.3536 9.35356L9.35356 15.3536C9.30718 15.4001 9.25207 15.4369 9.19139 15.4621C9.13072 15.4872 9.06568 15.5001 9 15.5Z",
    fill: props.foregroundColor
  }));
};

LssDeclaration.defaultProps = {
  altText: "Lss Declaration",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
LssDeclaration.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = LssDeclaration;
exports.default = _default;